import { Box } from '@mui/material'
import { useState } from 'react'
import { GLItemKind, GLItemStatus } from '../../../DTO/GLItemDTO'
import { SalesChartMode } from '../../../DTO/GLItemsDTO'
import mainservice from '../../../services/MainService'
import { MItem } from '../Menu'
import PlaningToolRoot from '../PlaningToolRoot'
import SalesPotentialChart, { SalesPotentialModeToggle } from './SalesPotentialChart'

function statusFromNav(): GLItemStatus | undefined {
  const raw = `${mainservice.nav.getVal('status') || ''}`
  if (raw === 'all' || raw === '') {
    return undefined
  }
  const n = parseInt(raw, 10)
  return Number.isNaN(n) ? undefined : n
}

function chartModeFromNav(): SalesChartMode {
  const raw = `${mainservice.nav.getVal('chartMode') || ''}`
  return raw === 'project' ? 'project' : 'company'
}

export default function SalesPotentialPage() {
  const [mode, setMode] = useState<SalesChartMode>(() => chartModeFromNav())
  const initialStatus = statusFromNav()

  function changeMode(next: SalesChartMode) {
    setMode(next)
    mainservice.nav.setVal('chartMode', next)
  }

  return (
    <PlaningToolRoot
      standalone
      menuItem={MItem.dashboardDemo}
      mainContentClass="SalesPotentialPage flex flex-column"
    >
      <div className="contentHeader">
        <h2>Gewichtetes Potenzial</h2>
      </div>
      <Box sx={{ padding: 2 }}>
        <SalesPotentialModeToggle mode={mode} onChange={changeMode} />
        <SalesPotentialChart
          mode={mode}
          variant="full"
          kind={GLItemKind.marketing}
          initialStatus={initialStatus}
        />
      </Box>
    </PlaningToolRoot>
  )
}
